import React, { useState, useEffect } from 'react';
import {
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Modal,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Autocomplete,
  Collapse,
  FormGroup,
  FormControl,
  FormLabel,
  Switch,
  Typography,
  Alert,
  InputAdornment,
  Chip,
  Card,
  CardContent,
  CardHeader,
  Divider,
  IconButton,
  Tooltip,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Tabs,
  Tab,
  Grid,
  Avatar,
  Badge,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  MenuItem,
  Select,
  InputLabel
} from '@mui/material';
import dayjs from 'dayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import SearchIcon from '@mui/icons-material/Search';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ReorderIcon from '@mui/icons-material/Reorder';
import ShippingIcon from '@mui/icons-material/LocalShipping';
import DeliveryIcon from '@mui/icons-material/LocalShipping';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import BusinessIcon from '@mui/icons-material/Business';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import InventoryIcon from '@mui/icons-material/Inventory';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AddIcon from '@mui/icons-material/Add';

// Import API functions
import {
  getTransportLines,
  getRequirements, 
  getDriversByLine,
  getVehiclesByLineId,
  getTrailersByTransportLine,
  linkOrdersToShipment,
  updateOrderStop,
  updateShipmentLoadingTime,
  updateShipmentTransportDetails,
  setShipmentLoadingOrder,
  getShipmentLoadingPhaseInfo,
  updateOrderLoadingSequence,
  updateOrderDeliverySequence,
  updateOrderLoadingOrder,
  getShipmentSequences,
  createDriver,
  createVehicle,
  createTrailer,
  checkPlacasExist,
  checkRemolquePlacasExist
} from '../api';

const SettingModal = ({ isOpen, onClose, shipment, onSave, availableOrders = [], fetchShipments }) => {
  // Existing state variables
  const [transportLine, setTransportLine] = useState([]);
  const [selectedTransportLine, setSelectedTransportLine] = useState(null);
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [vehicles, setVehicles] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [remolques, setRemolques] = useState([]);
  const [selectedRemolque1, setSelectedRemolque1] = useState(null);
  const [selectedRemolque2, setSelectedRemolque2] = useState(null);
  const [isFullTrailer, setIsFullTrailer] = useState(false);
  const [isOrdersSectionOpen, setIsOrdersSectionOpen] = useState(false);
  const [pickupDate, setPickupDate] = useState(null);
  const [requirements, setRequirements] = useState([]);
  const [availableRequirements, setAvailableRequirements] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [stopNumbers, setStopNumbers] = useState({});
  const [validationErrors, setValidationErrors] = useState([]);
  const [formError, setFormError] = useState("");
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [searchOrderTerm, setSearchOrderTerm] = useState('');
  const [addressMismatchError, setAddressMismatchError] = useState("");
  // Añadir estado para almacenar la información de debug
  const [debugInfo, setDebugInfo] = useState(null);

  // New state variables for order loading sequence
  const [isOriginsSectionOpen, setIsOriginsSectionOpen] = useState(false);
  const [ordersByOrigin, setOrdersByOrigin] = useState({});
  const [orderLoadingSequence, setOrderLoadingSequence] = useState({});
  const [currentLoadingPhase, setCurrentLoadingPhase] = useState(0);
  const [totalLoadingPhases, setTotalLoadingPhases] = useState(0);
  const [currentOrigin, setCurrentOrigin] = useState("");
  const [loadingPhaseInfo, setLoadingPhaseInfo] = useState(null);

  // New state variables for individual order loading and delivery sequence
  const [isOrderSequenceSectionOpen, setIsOrderSequenceSectionOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState(0); // 0: loading, 1: delivery
  const [orderSequences, setOrderSequences] = useState({
    loading: {}, // { orderId: sequence_number }
    delivery: {} // { orderId: sequence_number }
  });
  const [ordersForSequence, setOrdersForSequence] = useState([]);

  // New states for grouping orders
  const [orderGroupsByOrigin, setOrderGroupsByOrigin] = useState({});
  const [orderGroupsByDestination, setOrderGroupsByDestination] = useState({});
  const [selectedGroup, setSelectedGroup] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  // States for quick-add modals
  const [isDriverModalOpen, setIsDriverModalOpen] = useState(false);
  const [isVehicleModalOpen, setIsVehicleModalOpen] = useState(false);
  const [isTrailerModalOpen, setIsTrailerModalOpen] = useState(false);
  // Solo mantener los campos básicos necesarios para el operador
  const [newDriver, setNewDriver] = useState({ 
    nombre: '', 
    apellido_paterno: '', 
    apellido_materno: '', 
    telefono: ''
  });
  const [newVehicle, setNewVehicle] = useState({ placas: '', tipo: '', modelo: '' });
  const [newTrailer, setNewTrailer] = useState({ placas: '', tipo: '', economico: '' });
  
  // Estados para validación de placas
  const [placasVehicleError, setPlacasVehicleError] = useState("");
  const [placasTrailerError, setPlacasTrailerError] = useState("");
  const [isValidatingVehiclePlacas, setIsValidatingVehiclePlacas] = useState(false);
  const [isValidatingTrailerPlacas, setIsValidatingTrailerPlacas] = useState(false);
  
  // Tipos de vehículos y remolques según la configuración existente
  const vehicleTypes = ["1.5 TONS", "3.5 TONS", "RABÓN", "TORTON", "TRACTO"];
  const trailerTypes = [
    "CAJA 53FT SECA", "CAJA 53FT REFRIGERADA", "CAJA 48FT SECA", 
    "CAJA 40FT SECA", "CAJA 40FT REFRIGERADA", "PLATAFORMA 40FT", 
    "LOWBOY", "CHASIS 40FT", "CHASIS 20FT"
  ];
  
  // Función debounce para limitar llamadas API durante la escritura
  const debounce = (func, delay) => {
    let timeoutId;
    return (...args) => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };

  // Funciones para validar placas
  const validateVehiclePlacas = async (placas) => {
    if (!placas || placas.trim().length < 3) return;
    
    // Validar que no contenga espacios ni caracteres especiales
    const regex = /^[A-Za-z0-9]*$/; // Solo permite letras y números
    if (!regex.test(placas)) {
      setPlacasVehicleError("Las placas no deben contener espacios ni caracteres especiales");
      return;
    }
    
    setIsValidatingVehiclePlacas(true);
    try {
      const response = await checkPlacasExist(placas.trim());
      if (response.exists) {
        // Si estamos seleccionando un vehículo existente, no mostrar error
        if (response.vehicle_id === newVehicle.id) {
          setPlacasVehicleError("");
        } else {
          setPlacasVehicleError(
            `Las placas ${placas} ya están registradas para la línea de transporte: ${response.linea_transporte.name}`
          );
        }
      } else {
        setPlacasVehicleError("");
      }
    } catch (error) {
      console.error("Error validating vehicle plates:", error);
      setPlacasVehicleError("");
    } finally {
      setIsValidatingVehiclePlacas(false);
    }
  };
  const validateTrailerPlacas = async (placas) => {
    if (!placas || placas.trim().length < 3) return;
    
    // Validar que no contenga espacios ni caracteres especiales
    const regex = /^[A-Za-z0-9]*$/; // Solo permite letras y números
    if (!regex.test(placas)) {
      setPlacasTrailerError("Las placas no deben contener espacios ni caracteres especiales");
      return;
    }
    
    setIsValidatingTrailerPlacas(true);
    try {
      const response = await checkRemolquePlacasExist(placas.trim());
      if (response.exists) {
        // Si estamos seleccionando un remolque existente, no mostrar error
        if (response.remolque_id === newTrailer.id) {
          setPlacasTrailerError("");
        } else {
          setPlacasTrailerError(
            `Las placas ${placas} ya están registradas para la línea de transporte: ${response.linea_transporte.name}`
          );
        }
      } else {
        setPlacasTrailerError("");
      }
    } catch (error) {
      console.error("Error validating trailer plates:", error);
      setPlacasTrailerError("");
    } finally {
      setIsValidatingTrailerPlacas(false);
    }
  };

  // Versiones "debounced" de las funciones de validación
  const debouncedValidateVehiclePlacas = debounce(validateVehiclePlacas, 500);
  const debouncedValidateTrailerPlacas = debounce(validateTrailerPlacas, 500);

  useEffect(() => {
    const fetchTransportLines = async () => {
      try {
        const data = await getTransportLines();
        
        if (!Array.isArray(data)) {
          throw new Error('Formato de datos inesperado: no es un array');
        }

        const activeLines = data.filter(line => line.active === true)
                               .sort((a, b) => a.name.localeCompare(b.name));
        setTransportLine(activeLines);
      } catch (error) {
        console.error('Error fetching transport lines:', error);
      }
    };

    fetchTransportLines();
  }, []);

  useEffect(() => {
    const fetchRequirements = async () => {
      try {
        const data = await getRequirements();
        setAvailableRequirements(data);
      } catch (error) {
        console.error('Error fetching requirements:', error);
      }
    };
    fetchRequirements();
  }, []);

  const resetAllState = () => {
    setSelectedTransportLine(null);
    setSelectedDriver(null);
    setSelectedVehicle(null);
    setSelectedRemolque1(null);
    setSelectedRemolque2(null);
    setIsFullTrailer(false);
    setPickupDate(null);
    setRequirements([]);
    setSelectedOrders([]);
    setStopNumbers({});
    setValidationErrors([]);
    setDrivers([]);
    setVehicles([]);
    setRemolques([]);
    setIsOrdersSectionOpen(false);
    setIsOriginsSectionOpen(false);
    setOrdersByOrigin({});
    setOrderLoadingSequence({});
    setCurrentLoadingPhase(0);
    setTotalLoadingPhases(0);
    setCurrentOrigin("");
    setLoadingPhaseInfo(null);
    setIsOrderSequenceSectionOpen(false);
    setSelectedTab(0);
    setOrderSequences({ loading: {}, delivery: {} });
    setOrdersForSequence([]);
    setOrderGroupsByOrigin({});
    setOrderGroupsByDestination({});
    setSelectedGroup(null);
    setDragActive(false);
  };

  useEffect(() => {
    if (shipment) {
      if (shipment.pickup_date) {
        setPickupDate(dayjs(shipment.pickup_date));
      }

      if (shipment.requerimientos) {
        const reqs = shipment.requerimientos.split(", ").filter(Boolean);
        setRequirements(reqs);
      }

      if (shipment.orders && shipment.orders.length > 0) {
        const orderIds = shipment.orders.map(order => order.id);
        setSelectedOrders(orderIds);
        
        const stops = {};
        shipment.orders.forEach(order => {
          if (order.Stop) {
            stops[order.id] = order.Stop;
          }
        });
        setStopNumbers(stops);

        // Organizar automáticamente las órdenes por origen y destino cuando se abre el modal
        setTimeout(() => {
          groupOrdersByOriginAndDestination(shipment.orders);
        }, 100);
      }
    } else {
      resetAllState();
    }

    return () => {
      resetAllState();
    };
  }, [shipment]);

  useEffect(() => {
    const initializeTransportLine = async () => {
      try {
        const activeLines = await getTransportLines();
        
        const filteredLines = activeLines.filter(line => line.active === true)
                                  .sort((a, b) => a.name.localeCompare(b.name));
        setTransportLine(filteredLines);

        if (shipment?.Lt) {
          const foundLt = filteredLines.find(lt => lt.name === shipment.Lt);
          if (foundLt) {
            setSelectedTransportLine(foundLt);
            
            const dataDrivers = await getDriversByLine(foundLt.id);
            setDrivers(dataDrivers);

            if (shipment.driver) {
              // Buscar conductor por nombre completo o nombre parcial
              const foundDriver = dataDrivers.find(d => {
                const fullName = `${d.nombre} ${d.apellido_paterno}${d.apellido_materno ? ' ' + d.apellido_materno : ''}`.trim();
                const partialName = `${d.nombre} ${d.apellido_paterno}`.trim();
                return fullName === shipment.driver || partialName === shipment.driver;
              });
              
              if (foundDriver) {
                setSelectedDriver(foundDriver);
              }
            }

            const dataVehicles = await getVehiclesByLineId(foundLt.id);
            setVehicles(dataVehicles);

            if (shipment.vehicle) {
              const foundVehicle = dataVehicles.find(v => v.placas === shipment.vehicle);
              if (foundVehicle) {
                setSelectedVehicle(foundVehicle);
                
                if (foundVehicle.tipo === "TRACTO") {
                  const dataRemolques = await getTrailersByTransportLine(foundLt.id);
                  setRemolques(dataRemolques);
                  
                  if (shipment.remolque1) {
                    const foundRemolque1 = dataRemolques.find(r => r.placas === shipment.remolque1);
                    if (foundRemolque1) {
                      setSelectedRemolque1(foundRemolque1);
                    }
                  }
                  
                  if (shipment.remolque2) {
                    setIsFullTrailer(true);
                    const foundRemolque2 = dataRemolques.find(r => r.placas === shipment.remolque2);
                    if (foundRemolque2) {
                      setSelectedRemolque2(foundRemolque2);
                    }
                  }
                }
              }
            }
          }
        }
      } catch (error) {
        console.error('Error loading transport data:', error);
      }
    };

    initializeTransportLine();
  }, [shipment]);

  const handleLtChange = async (event, value) => {
    setSelectedTransportLine(value);
    setSelectedDriver(null);
    setSelectedVehicle(null);
    setSelectedRemolque1(null);
    setSelectedRemolque2(null);
    setRemolques([]);
    
    if (value && value.id) {
      try {
        const dataDrivers = await getDriversByLine(value.id);
        setDrivers(dataDrivers);

        const dataVehicles = await getVehiclesByLineId(value.id);
        setVehicles(dataVehicles);

        if (shipment && shipment.driver) {
          // Buscar conductor por nombre completo o nombre parcial
          const foundDriver = dataDrivers.find(d => {
            const fullName = `${d.nombre} ${d.apellido_paterno}${d.apellido_materno ? ' ' + d.apellido_materno : ''}`.trim();
            const partialName = `${d.nombre} ${d.apellido_paterno}`.trim();
            return fullName === shipment.driver || partialName === shipment.driver;
          });
          
          if (foundDriver) {
            setSelectedDriver(foundDriver);
          }
        }

        if (shipment && shipment.vehicle) {
          const foundVehicle = dataVehicles.find(v => v.placas === shipment.vehicle);
          if (foundVehicle) {
            setSelectedVehicle(foundVehicle);
          }
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setDrivers([]);
        setVehicles([]);
      }
    } else {
      setDrivers([]);
      setVehicles([]);
    }
  };

  const handleDriverChange = (event, value) => {
    setSelectedDriver(value);
  };

  const handleVehicleChange = async (event, value) => {
    setSelectedVehicle(value);
    setSelectedRemolque1(null);
    setSelectedRemolque2(null);
    setIsFullTrailer(false);
    
    if (value && value.tipo === "TRACTO" && selectedTransportLine) {
      try {
        const data = await getTrailersByTransportLine(selectedTransportLine.id);
        setRemolques(data);
      } catch (error) {
        console.error('Error fetching remolques:', error);
        setRemolques([]);
      }
    } else {
      setRemolques([]);
    }
  };

  const handleRemolque1Change = (event, value) => {
    setSelectedRemolque1(value);
    if (formError === 'Para un vehículo tipo TRACTO, debe seleccionar al menos un remolque.') {
      setFormError("");
    }
  };

  const handleRemolque2Change = (event, value) => {
    setSelectedRemolque2(value);
  };

  const handleFullTrailerChange = (event) => {
    setIsFullTrailer(event.target.checked);
    if (event.target.checked) {
      if (selectedRemolque1 && selectedRemolque1.tipo !== "CAJA 40FT SECA") {
        setSelectedRemolque1(null);
      }
    } else {
      setSelectedRemolque2(null);
    }
  };

  const handleRequirementChange = (requirement) => {
    setRequirements((prev) =>
      prev.includes(requirement) ? prev.filter((req) => req !== requirement) : [...prev, requirement]
    );
  };

  const handleSelectAllRequirements = () => {
    if (requirements.length === availableRequirements.length) {
      setRequirements([]);
    } else {
      setRequirements(availableRequirements.map(req => req.requerimiento));
    }
  };

  const toggleOrdersSection = () => {
    setIsOrdersSectionOpen((prev) => !prev);
    if (!isOrdersSectionOpen) setSearchOrderTerm('');
  };

  // Add logic to automatically group selected orders into loading sequence and delivery stops
  const toggleOrderSelection = (orderId) => {
    setSelectedOrders((prev) => {
      const newSelectedOrders = prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId];

      // Automatically group orders by origin and destination
      const selectedOrdersDetails = availableOrders.filter(order => newSelectedOrders.includes(order.id));
      groupOrdersByOriginAndDestination(selectedOrdersDetails);

      return newSelectedOrders;
    });
  };

  const resetSelectedOrders = () => {
    setSelectedOrders([]);
    setStopNumbers({});
  };

  const haveSameDestination = (order1, order2) => {
    return order1.City === order2.City && 
           order1.address === order2.address &&
           order1.customer === order2.customer;
  };

  const getAddressDisplay = (order) => {
    const addressParts = [];
    if (order.address) addressParts.push(order.address);
    return addressParts.length > 0 ? addressParts.join(', ') : 'Sin dirección';
  };

const handleStopNumberChange = (orderId, stopNumber) => {
  setStopNumbers((prev) => ({
    ...prev,
    [orderId]: stopNumber,
  }));
};

const handleLoadingOrderChange = (orderId, loadingOrder) => {
  setOrderSequences((prev) => ({
    ...prev,
    loading: {
      ...prev.loading,
      [orderId]: loadingOrder,
    },
  }));
};

// Update stop numbers and loading orders based on badge positions
const updateStopNumbersAndLoadingOrders = () => {
  const updatedStopNumbers = {};
  const updatedLoadingOrders = {};

  // Update based on badge positions for loading orders
  Object.entries(orderGroupsByOrigin).forEach(([originKey, group]) => {
    group.orders.forEach((order) => {
      updatedLoadingOrders[order.id] = group.sequenceNumber;
    });
  });

  // Update based on badge positions for stop numbers
  Object.entries(orderGroupsByDestination).forEach(([destKey, group]) => {
    group.orders.forEach((order) => {
      updatedStopNumbers[order.id] = group.stopNumber;
    });
  });

  setStopNumbers(updatedStopNumbers);
  setOrderSequences((prev) => ({
    ...prev,
    loading: updatedLoadingOrders,
  }));
};

// Ensure this function is called whenever the order groups are updated
useEffect(() => {
  if (selectedOrders.length > 0) {
    updateStopNumbersAndLoadingOrders();
  }
}, [orderGroupsByOrigin, orderGroupsByDestination]);

  const assignOrdersToShipment = async () => {
    try {
      // Verificar qué órdenes ya están asociadas con este embarque
      const existingOrderIds = shipment && shipment.orders ? shipment.orders.map(order => order.id) : [];
      
      // Filtrar para obtener solo las órdenes nuevas que no están en el embarque actual
      const newOrderIds = selectedOrders.filter(orderId => !existingOrderIds.includes(orderId));
      
      // Solo llamar a la API con las órdenes nuevas
      if (newOrderIds.length > 0) {
        await linkOrdersToShipment(shipment.id, newOrderIds);
        console.log('Nuevas órdenes asignadas correctamente');
      } else {
        console.log('No hay nuevas órdenes para asignar');
      }
  
      // Actualizar los números de parada para todas las órdenes seleccionadas
      await Promise.all(
        selectedOrders.map(async (orderId) => {
          await updateOrderStop(orderId, stopNumbers[orderId] || 1);
        })
      );
      
      // Eliminado el cierre del modal y la actualización de la lista para permitir que 
      // el resto de la configuración se guarde en el mismo flujo
      
    } catch (error) {
      console.error('Error al asignar órdenes:', error);
      throw error; // Propagar el error para manejarlo en handleSave
    }
  };

  const formatRequirements = (requirements) => {
    return requirements.join(", ");
  };

  const validateStopNumbers = () => {
    const errors = [];
    
    selectedOrders.forEach(orderId => {
      if (!stopNumbers[orderId]) {
        const order = availableOrders.find(o => o.id === orderId);
        if (order) {
          errors.push(`Selecciona una parada para la orden: ${order.Order_number}`);
        }
      }
    });
    
    if (addressMismatchError) {
      errors.push(addressMismatchError);
    }
    
    setValidationErrors(errors);
    return errors.length === 0;
  };

  const fetchLoadingPhaseInfo = async () => {
    if (shipment && shipment.id) {
      try {
        const info = await getShipmentLoadingPhaseInfo(shipment.id);
        setLoadingPhaseInfo(info);
        setCurrentLoadingPhase(info.current_phase);
        setTotalLoadingPhases(info.total_phases);
        setCurrentOrigin(info.current_origin);
      } catch (error) {
        console.error("Error fetching loading phase info:", error);
      }
    }
  };

  useEffect(() => {
    fetchLoadingPhaseInfo();
  }, [shipment]);

  // Group orders by origin
  useEffect(() => {
    if (shipment && shipment.orders && shipment.orders.length > 0) {
      const groupedByOrigin = shipment.orders.reduce((acc, order) => {
        const origin = order.Origin || 'Sin origen';
        if (!acc[origin]) {
          acc[origin] = [];
        }
        acc[origin].push(order);
        return acc;
      }, {});
      
      setOrdersByOrigin(groupedByOrigin);
      
      // Initialize loading sequence based on existing data or default to sequential order
      const initialSequence = {};
      let sequenceCounter = 1;
      
      // If shipment has loading_sequence defined, use it
      if (shipment.loading_sequence) {
        Object.keys(shipment.loading_sequence).forEach(origin => {
          initialSequence[origin] = shipment.loading_sequence[origin];
        });
      } else {
        // Otherwise create a default sequence based on origins
        Object.keys(groupedByOrigin).forEach(origin => {
          initialSequence[origin] = sequenceCounter++;
        });
      }
      
      setOrderLoadingSequence(initialSequence);
    }
  }, [shipment]);

  const toggleOriginsSection = () => {
    setIsOriginsSectionOpen((prev) => !prev);
  };

  // Function to move an origin up in the loading sequence
  const moveOriginUp = (origin) => {
    const currentOrder = orderLoadingSequence[origin];
    if (currentOrder <= 1) return; // Can't move up if already first
    
    const newSequence = {...orderLoadingSequence};
    
    // Find the origin that has the previous order
    const originToSwapWith = Object.keys(newSequence).find(key => 
      newSequence[key] === currentOrder - 1
    );
    
    if (originToSwapWith) {
      newSequence[origin] = currentOrder - 1;
      newSequence[originToSwapWith] = currentOrder;
      setOrderLoadingSequence(newSequence);
    }
  };

  // Function to move an origin down in the loading sequence
  const moveOriginDown = (origin) => {
    const currentOrder = orderLoadingSequence[origin];
    const maxOrder = Object.values(orderLoadingSequence).length;
    if (currentOrder >= maxOrder) return; // Can't move down if already last
    
    const newSequence = {...orderLoadingSequence};
    
    // Find the origin that has the next order
    const originToSwapWith = Object.keys(newSequence).find(key => 
      newSequence[key] === currentOrder + 1
    );
    
    if (originToSwapWith) {
      newSequence[origin] = currentOrder + 1;
      newSequence[originToSwapWith] = currentOrder;
      setOrderLoadingSequence(newSequence);
    }
  };

  const saveLoadingSequence = async () => {
    if (!shipment || !shipment.id || Object.keys(orderLoadingSequence).length === 0) {
      console.log("saveLoadingSequence: Missing shipment or orderLoadingSequence is empty.");
      return;
    }

    try {
      console.log("saveLoadingSequence: Preparing to save loading sequence.", {
        shipmentId: shipment.id,
        orderLoadingSequence,
      });

      // Prepare the request payload
      const orderGroups = Object.entries(orderLoadingSequence).map(([origin, loadingOrder]) => {
        console.log(`saveLoadingSequence: Adding origin ${origin} with loading order ${loadingOrder}`);
        return {
          origin,
          loading_order: loadingOrder,
          order_ids: ordersByOrigin[origin]?.map(order => order.id) || [],
        };
      });

      console.log("saveLoadingSequence: Order groups prepared.", orderGroups);

      await setShipmentLoadingOrder(shipment.id, { order_groups: orderGroups });

      // Fetch updated loading phase info to validate current_origin
      console.log("saveLoadingSequence: Fetching updated loading phase info.");
      await fetchLoadingPhaseInfo();

      console.log("saveLoadingSequence: Loading sequence saved successfully.");
    } catch (error) {
      console.error("saveLoadingSequence: Error saving loading sequence.", error);
    }
  };

  // Initialize the sequences for orders in the shipment
  useEffect(() => {
    if (shipment && shipment.orders && shipment.orders.length > 0) {
      setOrdersForSequence(shipment.orders);
      
      // Initialize loading sequence if exists in shipment
      if (shipment.loading_order_sequence) {
        setOrderSequences(prev => ({
          ...prev,
          loading: shipment.loading_order_sequence
        }));
      } else {
        // Create default loading sequence (incrementing by order id)
        const loadingSeq = {};
        shipment.orders.forEach((order, index) => {
          loadingSeq[order.id] = index + 1;
        });
        setOrderSequences(prev => ({
          ...prev,
          loading: loadingSeq
        }));
      }
      
      // Initialize delivery sequence if exists in shipment
      if (shipment.delivery_order_sequence) {
        setOrderSequences(prev => ({
          ...prev,
          delivery: shipment.delivery_order_sequence
        }));
      } else {
        // Create default delivery sequence (by stop number)
        const deliverySeq = {};
        const ordersByStop = [...shipment.orders].sort((a, b) => 
          (a.Stop || 999) - (b.Stop || 999)
        );
        
        ordersByStop.forEach((order, index) => {
          deliverySeq[order.id] = index + 1;
        });
        setOrderSequences(prev => ({
          ...prev,
          delivery: deliverySeq
        }));
      }
    }
  }, [shipment]);

  // Use a new effect to load sequences from backend when modal opens
  useEffect(() => {
    const loadSequencesFromBackend = async () => {
      if (shipment && shipment.id && isOpen) {
        try {
          const sequencesData = await getShipmentSequences(shipment.id);
          console.log("DEBUG - Received sequences from backend:", sequencesData);
          
          // Mostrar el debug box con la información recibida
          setDebugInfo(sequencesData);
          
          // Actualizar el estado de orderSequences según lo recibido del backend
          setOrderSequences({
            loading: sequencesData.loading_sequence || {},
            delivery: sequencesData.delivery_sequence || {}
          });
          
          // Actualizar los stopNumbers basados en la secuencia de entrega
          if (sequencesData.delivery_sequence) {
            const newStopNumbers = {};
            Object.entries(sequencesData.delivery_sequence).forEach(([orderId, stopNum]) => {
              newStopNumbers[orderId] = stopNum.toString();
            });
            setStopNumbers(newStopNumbers);
          }
          
          // Si hay órdenes disponibles, organizar por origen y destino
          if (shipment.orders && shipment.orders.length > 0) {
            // Organizar una vez que tengamos las secuencias del backend
            // Esto garantiza que usamos los valores correctos
            groupOrdersByOriginAndDestinationWithSequences(
              shipment.orders, 
              sequencesData.loading_sequence || {},
              sequencesData.delivery_sequence || {}
            );
          }
        } catch (error) {
          console.error("Error loading sequences from backend:", error);
        }
      }
    };
    
    loadSequencesFromBackend();
  }, [shipment, isOpen]);

  const toggleOrderSequenceSection = () => {
    setIsOrderSequenceSectionOpen((prev) => !prev);
  };
  
  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  
  // Move an order up in the sequence
  const moveOrderUp = (orderId, sequenceType) => {
    const currentSequences = { ...orderSequences };
    const currentSequence = currentSequences[sequenceType];
    const currentPosition = currentSequence[orderId];

    if (currentPosition <= 1) return; // Already at top

    // Find the order that is above this one
    const orderToSwapWith = Object.keys(currentSequence).find(
      (id) => currentSequence[id] === currentPosition - 1
    );

    if (orderToSwapWith) {
      currentSequence[orderId] = currentPosition - 1;
      currentSequence[orderToSwapWith] = currentPosition;

      setOrderSequences({
        ...orderSequences,
        [sequenceType]: currentSequence,
      });
    }
  };

  // Move an order down in the sequence
  const moveOrderDown = (orderId, sequenceType) => {
    const currentSequences = { ...orderSequences };
    const currentSequence = currentSequences[sequenceType];
    const currentPosition = currentSequence[orderId];
    const maxPosition = Object.keys(currentSequence).length;

    if (currentPosition >= maxPosition) return; // Already at bottom

    // Find the order that is below this one
    const orderToSwapWith = Object.keys(currentSequence).find(
      (id) => currentSequence[id] === currentPosition + 1
    );

    if (orderToSwapWith) {
      currentSequence[orderId] = currentPosition + 1;
      currentSequence[orderToSwapWith] = currentPosition;

      setOrderSequences({
        ...orderSequences,
        [sequenceType]: currentSequence,
      });
    }
  };

  // Save order sequences to backend
  const saveOrderSequences = async () => {
    if (!shipment || !shipment.id) {
      return;
    }
    
    try {
      // Save loading sequence
      await updateOrderLoadingSequence(shipment.id, {
        order_sequence: orderSequences.loading
      });
      
      // Save delivery sequence
      await updateOrderDeliverySequence(shipment.id, {
        order_sequence: orderSequences.delivery
      });
      
      // Actualizar también el campo loading_order en las órdenes individuales
      const updatePromises = selectedOrders.map(orderId => {
        // Asegurar que cada orden tenga un número de carga asignado
        const loadingOrder = orderSequences.loading[orderId] || 1;
        
        // Usar la función de API dedicada para esta actualización
        return updateOrderLoadingOrder(orderId, loadingOrder);
      });
      
      await Promise.all(updatePromises);
      
      console.log("Order sequences and loading_order saved successfully");
    } catch (error) {
      console.error("Error saving order sequences:", error);
      setFormError("Error al guardar las secuencias de órdenes: " + (error.message || "Error desconocido"));
    }
  };

  const groupOrdersByOriginAndDestination = (orders) => {
    if (!orders || orders.length === 0) return;
    
    // Agrupar órdenes por origen
    const byOrigin = {};
    // Agrupar órdenes por destino
    const byDestination = {};
    
    orders.forEach(order => {
      // Origen
      const origin = order.Origin || 'Sin origen';
      if (!byOrigin[origin]) {
        byOrigin[origin] = {
          name: origin,
          orders: [],
          sequenceNumber: null
        };
      }
      byOrigin[origin].orders.push(order);
      
      // Destino (combina Ciudad y Dirección)
      const destKey = `${order.City || 'Sin ciudad'} - ${order.address || 'Sin dirección'}`;
      if (!byDestination[destKey]) {
        byDestination[destKey] = {
          name: destKey,
          orders: [],
          stopNumber: null
        };
      }
      byDestination[destKey].orders.push(order);
    });
    
    // Establece los números de secuencia basados en el agrupamiento
    let loadingSeq = 1;
    Object.values(byOrigin).forEach(group => {
      if (!group.sequenceNumber) {
        group.sequenceNumber = loadingSeq++;
        
        // Asigna el mismo número de secuencia de carga a todas las órdenes de este origen
        group.orders.forEach(order => {
          setOrderSequences(prev => ({
            ...prev,
            loading: {
              ...prev.loading,
              [order.id]: group.sequenceNumber
            }
          }));
        });
      }
    });
    
    // Establece los números de parada basados en el agrupamiento por destino
    let stopSeq = 1;
    Object.values(byDestination).forEach(group => {
      if (!group.stopNumber && stopSeq <= 3) { // Limitamos a 3 paradas
        group.stopNumber = stopSeq++;
        
        // Asigna el mismo número de parada a todas las órdenes de este destino
        group.orders.forEach(order => {
          setStopNumbers(prev => ({
            ...prev,
            [order.id]: group.stopNumber
          }));
          
          setOrderSequences(prev => ({
            ...prev,
            delivery: {
              ...prev.delivery,
              [order.id]: group.stopNumber
            }
          }));
        });
      }
    });
    
    setOrderGroupsByOrigin(byOrigin);
    setOrderGroupsByDestination(byDestination);
  };

  const groupOrdersByOriginAndDestinationWithSequences = (orders, loadingSequence = {}, deliverySequence = {}) => {
    if (!orders || orders.length === 0) return;
    
    // Agrupar órdenes por origen
    const byOrigin = {};
    // Agrupar órdenes por destino
    const byDestination = {};
    
    orders.forEach(order => {
      // Origen
      const origin = order.Origin || 'Sin origen';
      if (!byOrigin[origin]) {
        byOrigin[origin] = {
          name: origin,
          orders: [],
          sequenceNumber: null
        };
      }
      byOrigin[origin].orders.push(order);
      
      // Destino (combina Ciudad y Dirección)
      const destKey = `${order.City || 'Sin ciudad'} - ${order.address || 'Sin dirección'}`;
      if (!byDestination[destKey]) {
        byDestination[destKey] = {
          name: destKey,
          orders: [],
          stopNumber: null
        };
      }
      byDestination[destKey].orders.push(order);
    });
    
    // Asignar números de secuencia a los grupos basados en la primera orden de cada grupo
    Object.values(byOrigin).forEach(group => {
      if (group.orders.length > 0) {
        const firstOrderId = group.orders[0].id;
        // Intentar obtener el loading_order de las secuencias recibidas
        if (loadingSequence[firstOrderId]) {
          group.sequenceNumber = loadingSequence[firstOrderId];
        } else if (group.orders[0].loading_order) {
          // Si no está en las secuencias pero la orden tiene loading_order
          group.sequenceNumber = group.orders[0].loading_order;
        } else {
          // Si no hay ninguna información de secuencia, asignar por defecto
          const originsList = Object.keys(byOrigin);
          const originIndex = originsList.indexOf(group.name);
          group.sequenceNumber = originIndex + 1;
        }
      }
    });
    
    // Asignar números de parada a los grupos basados en la primera orden de cada grupo
    Object.values(byDestination).forEach(group => {
      if (group.orders.length > 0) {
        const firstOrderId = group.orders[0].id;
        // Intentar obtener el stop de las secuencias recibidas
        if (deliverySequence[firstOrderId]) {
          group.stopNumber = deliverySequence[firstOrderId].toString();
        } else if (group.orders[0].Stop) {
          // Si no está en las secuencias pero la orden tiene Stop
          group.stopNumber = group.orders[0].Stop.toString();
        } else {
          // Si no hay ninguna información de secuencia, asignar por defecto
          const destList = Object.keys(byDestination);
          const destIndex = destList.indexOf(group.name);
          if (destIndex < 3) { // Limitamos a 3 paradas
            group.stopNumber = (destIndex + 1).toString();
          }
        }
      }
    });
    
    // Ordenar los grupos por número de secuencia para visualización
    setOrderGroupsByOrigin(byOrigin);
    setOrderGroupsByDestination(byDestination);
    
    // Actualizar también los estados de orderSequences y stopNumbers para mantener todo sincronizado
    const newLoadingSequence = {};
    const newStopNumbers = {};
    
    orders.forEach(order => {
      const origin = order.Origin || 'Sin origen';
      if (byOrigin[origin] && byOrigin[origin].sequenceNumber) {
        newLoadingSequence[order.id] = byOrigin[origin].sequenceNumber;
      }
      
      const destKey = `${order.City || 'Sin ciudad'} - ${order.address || 'Sin dirección'}`;
      if (byDestination[destKey] && byDestination[destKey].stopNumber) {
        newStopNumbers[order.id] = byDestination[destKey].stopNumber;
      }
    });
    
    setOrderSequences(prev => ({
      ...prev,
      loading: {...prev.loading, ...newLoadingSequence}
    }));
    
    setStopNumbers(prev => ({...prev, ...newStopNumbers}));
    
    console.log('DEBUG - Groups organized with sequences:', {
      byOrigin,
      byDestination,
      loadingSequences: newLoadingSequence,
      stopNumbers: newStopNumbers
    });
  };

  const handleSave = async () => {
    setFormError("");
    
    if (selectedVehicle?.tipo === "TRACTO" && !selectedRemolque1) {
      setFormError('Para un vehículo tipo TRACTO, debe seleccionar al menos un remolque.');
      return;
    }

    if (!validateStopNumbers()) {
      return;
    }
    try {
      if (!pickupDate) {
        setFormError('Por favor, selecciona una fecha y hora de carga.');
        return;
      }

      await assignOrdersToShipment();

      const formattedPickupDate = pickupDate.format('YYYY-MM-DDTHH:mm');
      
      await updateShipmentLoadingTime(shipment.id, formattedPickupDate);

      const formattedRequirements = formatRequirements(requirements);

      const transportDetails = {
        Lt: selectedTransportLine?.name || null,
        driver: selectedDriver ? `${selectedDriver.nombre} ${selectedDriver.apellido_paterno} ${selectedDriver.apellido_materno || ''}` : null,
        vehicle: selectedVehicle?.placas || null,
        requerimientos: formattedRequirements,
        remolque1: selectedRemolque1?.placas || null,
        remolque2: isFullTrailer ? (selectedRemolque2?.placas || null) : null,
      };

      console.log('Información enviada para update-transport-details:', transportDetails);

      await updateShipmentTransportDetails(shipment.id, transportDetails);
      
      // Save loading sequence if defined
      if (Object.keys(orderLoadingSequence).length > 0) {
        await saveLoadingSequence();
      }

      // Save individual order sequences if defined
      if (Object.keys(orderSequences.loading).length > 0) {
        await saveOrderSequences();
      }

      console.log('Configuración guardada correctamente.');

      fetchShipments();
      onClose();
    } catch (error) {
      console.error('Error al guardar la configuración:', error);
      setFormError('Hubo un error al guardar la configuración. Por favor, inténtalo de nuevo.');
    }
  };

  const handleClose = () => {
    resetAllState();
    onClose();
  };

  useEffect(() => {
    if (shipment && availableOrders && availableOrders.length > 0) {
      const filtered = availableOrders.filter(order => {
        // Verificar que la orden tenga TANTO fecha como hora de cita
        const hasAppointmentDate = Boolean(order.Appointment);
        const hasAppointmentTime = Boolean(order.Appointment_hr);
        const hasCompleteAppointment = hasAppointmentDate && hasAppointmentTime;
        
        const matchesClient = order.cuenta === shipment.vendor || order.client_name === shipment.vendor;
        const matchesSearch = !searchOrderTerm || 
                             order.Order_number?.toLowerCase().includes(searchOrderTerm.toLowerCase());
        
        return matchesClient && hasCompleteAppointment && matchesSearch;
      });
      setFilteredOrders(filtered);
    } else {
      setFilteredOrders([]);
    }
  }, [availableOrders, shipment, searchOrderTerm]);

  if (!shipment) return null;

  const isStopNumberDisabled = (stopNumber) => {
    if (stopNumber === 2 && !Object.values(stopNumbers).includes("1")) {
      return true;
    }
    if (stopNumber === 3 && !Object.values(stopNumbers).includes("2")) {
      return true;
    }
    return false;
  };

  const isTractor = selectedVehicle?.tipo === "TRACTO";

  const handlePickupDateChange = (newDateTime) => {
    setPickupDate(newDateTime);
  };

  const handleOpenDriverModal = () => {
    setIsDriverModalOpen(true);
  };

  const handleCloseDriverModal = () => {
    setIsDriverModalOpen(false);
    setNewDriver({ nombre: '', apellido_paterno: '', apellido_materno: '', telefono: '' });
  };

  const handleSaveDriver = async () => {
    if (!selectedTransportLine) {
      setFormError('Debe seleccionar una línea de transporte antes de crear un operador');
      handleCloseDriverModal();
      return;
    }
    
    if (!newDriver.nombre || !newDriver.apellido_paterno) {
      return; // No guardar si faltan campos requeridos
    }
    
    try {
      // Agregar el ID de la línea de transporte al operador
      const driverData = {
        ...newDriver,
        linea_transporte_id: selectedTransportLine.id
      };
      
      const createdDriver = await createDriver(driverData);
      
      // Actualizar lista de operadores y seleccionar el nuevo
      setDrivers(prevDrivers => [...prevDrivers, createdDriver]);
      setSelectedDriver(createdDriver);
      
      handleCloseDriverModal();
    } catch (error) {
      console.error('Error al crear operador:', error);
      setFormError('Hubo un error al crear el operador. Por favor, inténtalo de nuevo.');
      handleCloseDriverModal();
    }
  };

  const handleOpenVehicleModal = () => {
    setIsVehicleModalOpen(true);
  };

  const handleCloseVehicleModal = () => {
    setIsVehicleModalOpen(false);
    setNewVehicle({ placas: '', tipo: '', modelo: '' });
  };

  const handleSaveVehicle = async () => {
    if (!selectedTransportLine) {
      setFormError('Debe seleccionar una línea de transporte antes de crear un vehículo');
      handleCloseVehicleModal();
      return;
    }
    
    if (!newVehicle.placas || !newVehicle.tipo || !newVehicle.modelo) {
      return; // No guardar si faltan campos requeridos
    }
    
    if (placasVehicleError) {
      setFormError('No se puede crear el vehículo: ' + placasVehicleError);
      handleCloseVehicleModal();
      return;
    }
    
    try {
      // Agregar el ID de la línea de transporte al vehículo
      const vehicleData = {
        ...newVehicle,
        linea_transporte_id: selectedTransportLine.id,
        estado: 'ACTIVO',
        año: new Date().getFullYear().toString()
      };
      
      const createdVehicle = await createVehicle(vehicleData);
      
      // Actualizar lista de vehículos y seleccionar el nuevo
      setVehicles(prevVehicles => [...prevVehicles, createdVehicle]);
      setSelectedVehicle(createdVehicle);
      
      handleCloseVehicleModal();
    } catch (error) {
      console.error('Error al crear vehículo:', error);
      setFormError('Hubo un error al crear el vehículo. Por favor, inténtalo de nuevo.');
      handleCloseVehicleModal();
    }
  };

  const handleOpenTrailerModal = () => {
    setIsTrailerModalOpen(true);
  };

  const handleCloseTrailerModal = () => {
    setIsTrailerModalOpen(false);
    setNewTrailer({ placas: '', tipo: '', economico: '' });
  };

  const handleSaveTrailer = async () => {
    if (!selectedTransportLine) {
      setFormError('Debe seleccionar una línea de transporte antes de crear un remolque');
      handleCloseTrailerModal();
      return;
    }
    
    if (!newTrailer.placas || !newTrailer.tipo) {
      return; // No guardar si faltan campos requeridos
    }
    
    if (placasTrailerError) {
      setFormError('No se puede crear el remolque: ' + placasTrailerError);
      handleCloseTrailerModal();
      return;
    }
    
    try {
      // Agregar el ID de la línea de transporte al remolque
      const trailerData = {
        ...newTrailer,
        linea_transporte_id: selectedTransportLine.id,
        año: new Date().getFullYear(),
        modelo: newTrailer.modelo || 'S/M', // Si no se especifica modelo, usar "S/M" (sin modelo)
        color: 'BLANCO' // Valor por defecto
      };
      
      const createdTrailer = await createTrailer(trailerData);
      
      // Actualizar lista de remolques y seleccionar el nuevo
      setRemolques(prevTrailers => [...prevTrailers, createdTrailer]);
      
      // Si es un vehículo tipo TRACTO, seleccionar automáticamente el remolque nuevo
      if (selectedVehicle && selectedVehicle.tipo === "TRACTO") {
        setSelectedRemolque1(createdTrailer);
      }
      
      handleCloseTrailerModal();
    } catch (error) {
      console.error('Error al crear remolque:', error);
      setFormError('Hubo un error al crear el remolque. Por favor, inténtalo de nuevo.');
      handleCloseTrailerModal();
    }
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box className="bg-white p-6 rounded-lg shadow-lg w-5/6 mx-auto mt-20 max-w-full" style={{ maxHeight: '90vh', overflow: 'auto' }}>
        <h2 className="text-xl font-bold mb-4">Configurar Transporte para {shipment.reference}</h2>

        {formError && (
          <Alert severity="error" className="mb-4">
            {formError}
          </Alert>
        )}
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Autocomplete
            value={selectedTransportLine}
            options={transportLine}
            getOptionLabel={(option) => option.name}
            onChange={handleLtChange}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Línea de transporte"
                margin="normal"
                required
              />
            )}
          />

          <div className="flex items-center">
            <Autocomplete
              className="flex-grow"
              value={selectedDriver}
              options={drivers}
              getOptionLabel={(option) => `${option.nombre} ${option.apellido_paterno} ${option.apellido_materno}`}
              onChange={handleDriverChange}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Operadores"
                  margin="normal"
                  required
                />
              )}
            />
            <IconButton onClick={handleOpenDriverModal} sx={{ mt: 1, ml: 1 }}>
              <AddIcon />
            </IconButton>
          </div>

          <div className="flex items-center">
            <Autocomplete
              className="flex-grow"
              value={selectedVehicle}
              options={vehicles}
              getOptionLabel={(option) => `${option.placas} - ${option.tipo} - ${option.modelo}`}
              onChange={handleVehicleChange}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Vehículos"
                  margin="normal"
                  required
                />
              )}
            />
            <IconButton onClick={handleOpenVehicleModal} sx={{ mt: 1, ml: 1 }}>
              <AddIcon />
            </IconButton>
          </div>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateTimePicker
              label="Fecha y Hora de Carga"
              value={pickupDate}
              onChange={handlePickupDateChange}
              ampm={false}
              minutesStep={5}
              format="DD/MM/YYYY HH:mm"
              slotProps={{ 
                textField: { 
                  fullWidth: true,
                  required: true,
                  margin: "normal"
                } 
              }}
            />
          </LocalizationProvider>
          
          {isTractor && (
            <>
              <div className="flex items-center">
                <Autocomplete
                  className="flex-grow"
                  value={selectedRemolque1}
                  options={remolques.filter(r => 
                    !isFullTrailer || r.tipo === "CAJA 40FT SECA"
                  )}
                  getOptionLabel={(option) => `${option.placas} - ${option.tipo} - ${option.economico}`}
                  onChange={handleRemolque1Change}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Remolque"
                      margin="normal"
                      required
                    />
                  )}
                />
                <IconButton onClick={handleOpenTrailerModal} sx={{ mt: 1, ml: 1 }}>
                  <AddIcon />
                </IconButton>
              </div>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={isFullTrailer}
                      onChange={handleFullTrailerChange}
                      name="fullTrailer"
                    />
                  }
                  label="FULL"
                />
                <Typography variant="body2" color="text.secondary" sx={{ ml: 1 }}>
                  (Seleccionar si el embarque requiere doble remolque)
                </Typography>
              </Box>
              
              {isFullTrailer && (
                <Autocomplete
                  value={selectedRemolque2}
                  options={remolques.filter(r => 
                    r.id !== selectedRemolque1?.id && 
                    r.tipo === "CAJA 40FT SECA"
                  )}
                  getOptionLabel={(option) => `${option.placas} - ${option.tipo} - ${option.economico}`}
                  onChange={handleRemolque2Change}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Remolque 2"
                      margin="normal"
                      required
                    />
                  )}
                />
              )}
            </>
          )}
        </div>

        <Paper elevation={3} className="p-4 mt-4">
          <FormControl component="fieldset">
            <FormLabel component="legend" className="text-sm font-medium text-gray-700">Requerimientos Adicionales</FormLabel>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={requirements.length === availableRequirements.length}
                    onChange={handleSelectAllRequirements}
                  />
                }
                label="Seleccionar todos"
              />
              {availableRequirements.map((requirement) => (
                <FormControlLabel
                  key={requirement.id}
                  control={
                    <Checkbox
                      checked={requirements.includes(requirement.requerimiento)}
                      onChange={() => handleRequirementChange(requirement.requerimiento)}
                    />
                  }
                  label={requirement.requerimiento}
                />
              ))}
            </FormGroup>
          </FormControl>
        </Paper>

        {/* Sección de órdenes disponibles */}
        <div className="mt-4">
          <Button onClick={toggleOrdersSection} variant="contained" color="primary">
            {isOrdersSectionOpen ? 'Ocultar Órdenes Disponibles' : 'Mostrar Órdenes Disponibles'}
          </Button>
          <Collapse in={isOrdersSectionOpen}>
            <div style={{ display: "flex", gap: "16px", width: "100%", marginTop: "16px" }}>
              <div style={{ flex: 1, minWidth: "50%" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "8px" }}>
                  <h3 style={{ fontSize: "18px", fontWeight: "600" }}>
                    Órdenes Disponibles ({filteredOrders.length})
                  </h3>
                  <TextField
                    placeholder="Buscar orden..."
                    size="small"
                    value={searchOrderTerm}
                    onChange={(e) => setSearchOrderTerm(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon fontSize="small" />
                        </InputAdornment>
                      ),
                    }}
                    style={{ width: "180px" }}
                  />
                </div>
                {filteredOrders.length > 0 ? (
                  <TableContainer component={Paper} style={{ maxHeight: "300px", overflowY: "auto", overflowX: "hidden" }}>
                  <Table style={{ tableLayout: "fixed", width: "100%" }}>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ width: "10%" }}>Seleccionar</TableCell>
                        <TableCell style={{ width: "20%" }}>DO</TableCell>
                        <TableCell style={{ width: "20%" }}>Cliente</TableCell>
                        <TableCell style={{ width: "25%" }}>Origen</TableCell>
                        <TableCell style={{ width: "25%" }}>Destino</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredOrders.map((order) => (
                        <TableRow key={order.id}>
                          <TableCell>
                            <Checkbox
                              checked={selectedOrders.includes(order.id)}
                              onChange={() => toggleOrderSelection(order.id)}
                              color="primary"
                            />
                          </TableCell>
                          <TableCell style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {order.Order_number}
                          </TableCell>
                          <TableCell style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {order.client_name || order.cuenta}
                          </TableCell>
                          <TableCell style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {order.Origin || "-"}
                          </TableCell>
                          <TableCell style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {order.City} {order.address ? `(${order.address})` : ""}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                ) : (
                  <Paper elevation={0} style={{ padding: "16px", textAlign: "center", backgroundColor: "#f5f5f5" }}>
                    <Typography variant="body2" color="textSecondary">
                      No hay órdenes disponibles que coincidan con los criterios.
                    </Typography>
                  </Paper>
                )}
              </div>

              {/* Nueva sección visual para órdenes seleccionadas con agrupamiento automático */}
              <div style={{ flex: 1, minWidth: "50%" }}>
                <h3 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "8px" }}>
                  Órdenes Seleccionadas
                </h3>
                
                {selectedOrders.length > 0 && (
                  <div className="flex flex-col space-y-4">
                    {/* Sección de Carga */}
                    <div className="border border-blue-300 rounded-lg overflow-hidden">
                      <div className="bg-blue-100 p-2 flex items-center justify-between">
                        <div className="flex items-center">
                          <LocalShippingIcon className="text-blue-600 mr-2" />
                          <Typography variant="subtitle1" className="font-bold text-blue-800">
                            Secuencia de Carga
                          </Typography>
                        </div>
                        <Chip 
                          label={`${Object.keys(orderGroupsByOrigin).length || 0} origen(es)`} 
                          size="small" 
                          color="primary" 
                        />
                      </div>
                      
                      <Box className="p-3 bg-white">
                        {/* Lista de grupos de origen para carga */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                          {Object.entries(orderGroupsByOrigin).length > 0 ? (
                            Object.entries(orderGroupsByOrigin)
                              .sort(([,a], [,b]) => (a.sequenceNumber || 999) - (b.sequenceNumber || 999))
                              .map(([originKey, group], groupIndex) => (
                                <Card 
                                  key={originKey} 
                                  variant="outlined"
                                  className="bg-blue-50 relative"
                                >
                                  <CardContent className="p-2">
                                    <Badge
                                      badgeContent={group.sequenceNumber || '?'}
                                      color="primary"
                                      anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                      }}
                                      style={{ position: 'absolute', top: 8, left: 8 }}
                                    />
                                    
                                    <div className="flex items-center mb-1 pl-5 mt-5">
                                      <WarehouseIcon fontSize="small" className="text-blue-600 mr-1" />
                                      <Typography variant="subtitle2" className="font-bold">
                                        {group.name}
                                      </Typography>
                                    </div>
                                    
                                    <div className="ml-6 mt-2">
                                      {group.orders.map((order, orderIndex) => (
                                        <Chip 
                                          key={order.id}
                                          label={order.Order_number}
                                          size="small"
                                          className="m-0.5"
                                          variant="outlined"
                                          style={{
                                            backgroundColor: groupIndex === 0 ? '#e3f2fd' : 
                                                            groupIndex === 1 ? '#e8f5e9' : 
                                                            groupIndex === 2 ? '#fff8e1' : '#f5f5f5'
                                          }}
                                        />
                                      ))}
                                    </div>
                                    
                                    <div className="flex justify-end mt-2">
                                      <IconButton 
                                        size="small" 
                                        className="text-blue-600"
                                        onClick={() => {
                                          const newSeqNum = Math.max(1, (group.sequenceNumber || groupIndex + 1) - 1);
                                          const prevGroup = Object.entries(orderGroupsByOrigin)
                                            .find(([,g]) => g.sequenceNumber === newSeqNum);
                                          
                                          if (prevGroup) {
                                            const updatedGroups = {...orderGroupsByOrigin};
                                            updatedGroups[prevGroup[0]].sequenceNumber = group.sequenceNumber;
                                            updatedGroups[originKey].sequenceNumber = newSeqNum;
                                            
                                            group.orders.forEach(order => {
                                              handleLoadingOrderChange(order.id, newSeqNum);
                                            });
                                            prevGroup[1].orders.forEach(order => {
                                              handleLoadingOrderChange(order.id, group.sequenceNumber);
                                            });
                                            
                                            setOrderGroupsByOrigin(updatedGroups);
                                          }
                                        }}
                                        disabled={groupIndex === 0}
                                      >
                                        <ArrowUpwardIcon fontSize="small" />
                                      </IconButton>
                                      <IconButton 
                                        size="small"
                                        className="text-blue-600"
                                        onClick={() => {
                                          const newSeqNum = (group.sequenceNumber || groupIndex + 1) + 1;
                                          const nextGroup = Object.entries(orderGroupsByOrigin)
                                            .find(([,g]) => g.sequenceNumber === newSeqNum);
                                          
                                          if (nextGroup) {
                                            const updatedGroups = {...orderGroupsByOrigin};
                                            updatedGroups[nextGroup[0]].sequenceNumber = group.sequenceNumber;
                                            updatedGroups[originKey].sequenceNumber = newSeqNum;
                                            
                                            group.orders.forEach(order => {
                                              handleLoadingOrderChange(order.id, newSeqNum);
                                            });
                                            nextGroup[1].orders.forEach(order => {
                                              handleLoadingOrderChange(order.id, group.sequenceNumber);
                                            });
                                            
                                            setOrderGroupsByOrigin(updatedGroups);
                                          }
                                        }}
                                        disabled={groupIndex === Object.keys(orderGroupsByOrigin).length - 1}
                                      >
                                        <ArrowDownwardIcon fontSize="small" />
                                      </IconButton>
                                    </div>
                                  </CardContent>
                                </Card>
                              ))
                          ) : (
                            <Typography variant="body2" color="textSecondary" className="p-2 text-center col-span-2">
                              Presiona "Auto-organizar órdenes" para agrupar las órdenes por origen
                            </Typography>
                          )}
                        </div>
                      </Box>
                    </div>
                    
                    {/* Sección de Entrega (Paradas) */}
                    <div className="border border-pink-300 rounded-lg overflow-hidden">
                      <div className="bg-pink-100 p-2 flex items-center justify-between">
                        <div className="flex items-center">
                          <DeliveryIcon className="text-pink-600 mr-2" />
                          <Typography variant="subtitle1" className="font-bold text-pink-800">
                            Paradas de Entrega
                          </Typography>
                        </div>
                        <Chip 
                          label={`${Object.keys(orderGroupsByDestination).length || 0} destino(s)`} 
                          size="small" 
                          color="secondary" 
                        />
                      </div>
                      
                      <Box className="p-3 bg-white">
                        {/* Lista de grupos de destino para entrega */}
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
                          {Object.entries(orderGroupsByDestination).length > 0 ? (
                            Object.entries(orderGroupsByDestination)
                              .sort(([,a], [,b]) => (a.stopNumber || 999) - (b.stopNumber || 999))
                              .map(([destKey, group], groupIndex) => (
                                <Card 
                                  key={destKey} 
                                  variant="outlined"
                                  className="bg-pink-50 relative"
                                >
                                  <CardContent className="p-2">
                                    <Badge
                                      badgeContent={group.stopNumber || '?'}
                                      color="secondary"
                                      anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                      }}
                                      style={{ position: 'absolute', top: 8, left: 8 }}
                                    />
                                    
                                    <div className="flex items-center mb-1 pl-5 mt-5">
                                      <LocationOnIcon fontSize="small" className="text-pink-600 mr-1" />
                                      <Typography variant="subtitle2" className="font-bold" noWrap>
                                        {group.name}
                                      </Typography>
                                    </div>
                                    
                                    <div className="ml-6 mt-2">
                                      {group.orders.map(order => (
                                        <Chip 
                                          key={order.id}
                                          label={order.Order_number}
                                          size="small"
                                          className="m-0.5"
                                          variant="outlined"
                                          style={{
                                            backgroundColor: groupIndex === 0 ? '#fce4ec' : 
                                                            groupIndex === 1 ? '#f3e5f5' : 
                                                            groupIndex === 2 ? '#ede7f6' : '#f5f5f5'
                                          }}
                                        />
                                      ))}
                                    </div>
                                    
                                    <div className="flex justify-between mt-2">
                                      <div>
                                        {/* El texto "Parada #X" se elimina porque ya tenemos el badge */}
                                      </div>
                                      <div className="flex items-center">
                                        <div className="flex flex-row">
                                          <IconButton 
                                            size="small" 
                                            className="text-pink-600"
                                            onClick={() => {
                                              // Verificar si tiene un número de parada asignado
                                              if (!group.stopNumber) return;
                                              
                                              const newStopNum = Math.max(1, parseInt(group.stopNumber) - 1);
                                              if (newStopNum === parseInt(group.stopNumber)) return; // Ya está en la primera parada
                                              
                                              const prevGroup = Object.entries(orderGroupsByDestination)
                                                .find(([,g]) => g.stopNumber && parseInt(g.stopNumber) === newStopNum);
                                              
                                              if (prevGroup) {
                                                const updatedGroups = {...orderGroupsByDestination};
                                                updatedGroups[prevGroup[0]].stopNumber = group.stopNumber;
                                                updatedGroups[destKey].stopNumber = newStopNum.toString();
                                                
                                                // Actualizar todas las órdenes en ambos grupos
                                                group.orders.forEach(order => {
                                                  handleStopNumberChange(order.id, newStopNum.toString());
                                                  
                                                  setOrderSequences(prev => ({
                                                    ...prev,
                                                    delivery: {
                                                      ...prev.delivery,
                                                      [order.id]: newStopNum
                                                    }
                                                  }));
                                                });
                                                
                                                prevGroup[1].orders.forEach(order => {
                                                  handleStopNumberChange(order.id, group.stopNumber);
                                                  
                                                  setOrderSequences(prev => ({
                                                    ...prev,
                                                    delivery: {
                                                      ...prev.delivery,
                                                      [order.id]: parseInt(group.stopNumber)
                                                    }
                                                  }));
                                                });
                                                
                                                setOrderGroupsByDestination(updatedGroups);
                                              }
                                            }}
                                            disabled={!group.stopNumber || parseInt(group.stopNumber) <= 1}
                                          >
                                            <ArrowUpwardIcon fontSize="small" />
                                          </IconButton>
                                          
                                          <IconButton 
                                            size="small"
                                            className="text-pink-600"
                                            onClick={() => {
                                              // Verificar si tiene un número de parada asignado
                                              if (!group.stopNumber) return;
                                              
                                              const newStopNum = parseInt(group.stopNumber) + 1;
                                              if (newStopNum > 3) return; // No permitir más de 3 paradas
                                              
                                              const nextGroup = Object.entries(orderGroupsByDestination)
                                                .find(([,g]) => g.stopNumber && parseInt(g.stopNumber) === newStopNum);
                                              
                                              if (nextGroup) {
                                                const updatedGroups = {...orderGroupsByDestination};
                                                updatedGroups[nextGroup[0]].stopNumber = group.stopNumber;
                                                updatedGroups[destKey].stopNumber = newStopNum.toString();
                                                
                                                // Actualizar todas las órdenes en ambos grupos
                                                group.orders.forEach(order => {
                                                  handleStopNumberChange(order.id, newStopNum.toString());
                                                  
                                                  setOrderSequences(prev => ({
                                                    ...prev,
                                                    delivery: {
                                                      ...prev.delivery,
                                                      [order.id]: newStopNum
                                                    }
                                                  }));
                                                });
                                                
                                                nextGroup[1].orders.forEach(order => {
                                                  handleStopNumberChange(order.id, group.stopNumber);
                                                  
                                                  setOrderSequences(prev => ({
                                                    ...prev,
                                                    delivery: {
                                                      ...prev.delivery,
                                                      [order.id]: parseInt(group.stopNumber)
                                                    }
                                                  }));
                                                });
                                                
                                                setOrderGroupsByDestination(updatedGroups);
                                              }
                                            }}
                                            disabled={!group.stopNumber || parseInt(group.stopNumber) >= 3 || 
                                                     !Object.values(orderGroupsByDestination).some(g => g.stopNumber && parseInt(g.stopNumber) === parseInt(group.stopNumber) + 1)}
                                          >
                                            <ArrowDownwardIcon fontSize="small" />
                                          </IconButton>
                                        </div>
                                      </div>
                                    </div>
                                  </CardContent>
                                </Card>
                              ))
                          ) : (
                            <Typography variant="body2" color="textSecondary" className="p-2 text-center col-span-2">
                              Presiona "Auto-organizar órdenes" para agrupar las órdenes por destino
                            </Typography>
                          )}
                        </div>
                      </Box>
                    </div>
                    
                    {/* Sección de tabla individual para configuración manual - COMENTADA TEMPORALMENTE
                    <div className="border border-gray-200 rounded-lg overflow-hidden">
                      <div className="bg-gray-100 p-2 flex items-center justify-between">
                        <div className="flex items-center">
                          <ReorderIcon className="text-gray-600 mr-2" />
                          <Typography variant="subtitle1" className="font-bold text-gray-800">
                            Configuración Manual (Individual)
                          </Typography>
                        </div>
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => {
                            setIsOrderSequenceSectionOpen(true);
                          }}
                        >
                          Vista Avanzada
                        </Button>
                      </div>
                      
                      <TableContainer style={{ maxHeight: "300px" }}>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell style={{backgroundColor: "#e3f2fd", fontWeight: "bold", width: "20%"}}>
                                Sec. Carga
                              </TableCell>
                              <TableCell style={{width: "60%", fontWeight: "bold"}}>Orden</TableCell>
                              <TableCell style={{backgroundColor: "#fce4ec", fontWeight: "bold", width: "20%"}}>
                                Parada
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {availableOrders
                              .filter((order) => selectedOrders.includes(order.id))
                              .map((order, index) => (
                                <TableRow key={order.id} style={{backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'}}>
                                  <TableCell style={{borderLeft: '3px solid #2196f3'}}>
                                    <select
                                      value={orderSequences.loading[order.id] || ""}
                                      onChange={(e) => handleLoadingOrderChange(order.id, e.target.value)}
                                      className="w-full p-1 border rounded bg-blue-50 text-sm"
                                    >
                                      <option value="">Selec.</option>
                                      {[...Array(selectedOrders.length).keys()].map((num) => (
                                        <option key={num + 1} value={num + 1}>{num + 1}</option>
                                      ))}
                                    </select>
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="body2" className="font-bold">
                                      {order.Order_number}
                                    </Typography>
                                    <Typography variant="caption" display="block" color="textSecondary">
                                      {order.Origin || 'Sin origen'} → {order.City || 'Sin ciudad'}
                                    </Typography>
                                  </TableCell>
                                  <TableCell style={{borderRight: '3px solid #e91e63'}}>
                                    <select
                                      value={stopNumbers[order.id] || ""}
                                      onChange={(e) => handleStopNumberChange(order.id, e.target.value)}
                                      className={addressMismatchError.includes(order.Order_number) 
                                        ? "border-red-500 w-full p-1 border rounded bg-red-50 text-sm" 
                                        : "w-full p-1 border rounded bg-pink-50 text-sm"}
                                    >
                                      <option value="">Selec.</option>
                                      {[...Array(3).keys()]
                                        .filter((num) => !isStopNumberDisabled(num + 1))
                                        .map((num) => (
                                          <option key={num + 1} value={num + 1}>{num + 1}</option>
                                        ))}
                                    </select>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                    */}
                    
                    {/* Leyenda */}
                    <Box className="mt-2 px-2 py-2 bg-gray-50 rounded border border-gray-200 text-sm">
                      <Typography variant="caption" className="flex items-center mb-1">
                        <LocalShippingIcon fontSize="small" className="mr-1" style={{color: '#2196f3', fontSize: 14}} /> 
                        <span className="font-semibold mx-1">Secuencia de Carga:</span> Las órdenes del mismo origen tendrán el mismo orden de carga
                      </Typography>
                      <Typography variant="caption" className="flex items-center">
                        <DeliveryIcon fontSize="small" className="mr-1" style={{color: '#e91e63', fontSize: 14}} /> 
                        <span className="font-semibold mx-1">Número de Parada:</span> Las órdenes con el mismo destino deben tener la misma parada
                      </Typography>
                    </Box>
                  </div>
                )}
                
                {addressMismatchError && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    {addressMismatchError}
                  </Alert>
                )}
              </div>
            </div>
          </Collapse>
        </div>

        {/* Debug Info - Comentado temporalmente. Descomentar cuando se necesite para debugging
        {debugInfo && (
          <Paper elevation={3} className="p-4 mt-4 bg-gray-100">
            <Typography variant="h6" className="mb-2">Debug Info</Typography>
            <Typography variant="body2" className="mb-1">
              <strong>Debug Data:</strong> {JSON.stringify(debugInfo, null, 2)}
            </Typography>
          </Paper>
        )}
        */}

        {validationErrors.length > 0 && (
          <div className="mt-4">
            {validationErrors.map((error, index) => (
              <p key={index} className="text-red-500 text-sm">{error}</p>
            ))}
          </div>
        )}

        <div className="flex justify-end space-x-2 mt-4">
          <Button onClick={handleClose} variant="outlined">
            Cancelar
          </Button>
          <Button 
            onClick={handleSave} 
            variant="contained" 
            color="primary"
            disabled={validationErrors.length > 0}
          >
            Guardar
          </Button>
        </div>

        {/* Quick-add modals */}
        <Dialog open={isDriverModalOpen} onClose={handleCloseDriverModal}>
          <DialogTitle>Agregar Nuevo Operador</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Ingresa la información del nuevo operador.
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Nombre"
              fullWidth
              value={newDriver.nombre}
              onChange={(e) => setNewDriver((prev) => ({ ...prev, nombre: e.target.value.toUpperCase() }))}
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
            <TextField
              margin="dense"
              label="Apellido Paterno"
              fullWidth
              value={newDriver.apellido_paterno}
              onChange={(e) => setNewDriver((prev) => ({ ...prev, apellido_paterno: e.target.value.toUpperCase() }))}
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
            <TextField
              margin="dense"
              label="Apellido Materno"
              fullWidth
              value={newDriver.apellido_materno}
              onChange={(e) => setNewDriver((prev) => ({ ...prev, apellido_materno: e.target.value.toUpperCase() }))}
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
            <TextField
              margin="dense"
              label="Teléfono"
              fullWidth
              value={newDriver.telefono}
              onChange={(e) => setNewDriver((prev) => ({ ...prev, telefono: e.target.value }))}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDriverModal}>Cancelar</Button>
            <Button onClick={handleSaveDriver} color="primary">Guardar</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={isVehicleModalOpen} onClose={handleCloseVehicleModal}>
          <DialogTitle>Agregar Nuevo Vehículo</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Ingresa la información del nuevo vehículo.
            </DialogContentText>            <TextField
              autoFocus
              margin="dense"
              label="Placas"
              fullWidth
              value={newVehicle.placas}              onChange={(e) => {
                // Eliminar espacios y caracteres especiales en tiempo real
                const cleanValue = e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
                setNewVehicle((prev) => ({ ...prev, placas: cleanValue }));
                debouncedValidateVehiclePlacas(cleanValue);
              }}
              onKeyPress={(e) => {
                // Prevenir directamente cualquier entrada de caracteres especiales o espacios
                const regex = /^[a-zA-Z0-9]$/;
                if (!regex.test(e.key)) {
                  e.preventDefault();
                }
              }}
              error={!!placasVehicleError}
              helperText={placasVehicleError}
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
            <FormControl fullWidth margin="dense">
              <InputLabel>Tipo</InputLabel>
              <Select
                value={newVehicle.tipo}
                onChange={(e) => setNewVehicle((prev) => ({ ...prev, tipo: e.target.value }))}
              >
                {vehicleTypes.map((type) => (
                  <MenuItem key={type} value={type}>{type}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              margin="dense"
              label="Modelo"
              fullWidth
              value={newVehicle.modelo}
              onChange={(e) => setNewVehicle((prev) => ({ ...prev, modelo: e.target.value.toUpperCase() }))}
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseVehicleModal}>Cancelar</Button>
            <Button onClick={handleSaveVehicle} color="primary">Guardar</Button>
          </DialogActions>
        </Dialog>

        <Dialog open={isTrailerModalOpen} onClose={handleCloseTrailerModal}>
          <DialogTitle>Agregar Nuevo Remolque</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Ingresa la información del nuevo remolque.
            </DialogContentText>            <TextField
              autoFocus
              margin="dense"
              label="Placas"
              fullWidth
              value={newTrailer.placas}
              onChange={(e) => {
                // Eliminar espacios y caracteres especiales
                const cleanValue = e.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
                setNewTrailer((prev) => ({ ...prev, placas: cleanValue }));
                debouncedValidateTrailerPlacas(cleanValue);
              }}
              onKeyPress={(e) => {
                // Prevenir directamente cualquier entrada de caracteres especiales o espacios
                const regex = /^[a-zA-Z0-9]$/;
                if (!regex.test(e.key)) {
                  e.preventDefault();
                }
              }}
              error={!!placasTrailerError}
              helperText={placasTrailerError}
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
            <FormControl fullWidth margin="dense">
              <InputLabel>Tipo</InputLabel>
              <Select
                value={newTrailer.tipo}
                onChange={(e) => setNewTrailer((prev) => ({ ...prev, tipo: e.target.value }))}
              >
                {trailerTypes.map((type) => (
                  <MenuItem key={type} value={type}>{type}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              margin="dense"
              label="Económico"
              fullWidth
              value={newTrailer.economico}
              onChange={(e) => setNewTrailer((prev) => ({ ...prev, economico: e.target.value.toUpperCase() }))}
              inputProps={{ style: { textTransform: 'uppercase' } }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseTrailerModal}>Cancelar</Button>
            <Button onClick={handleSaveTrailer} color="primary">Guardar</Button>
          </DialogActions>
        </Dialog>
      </Box>
    </Modal>
  );
};

export default SettingModal;